// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingOutlinedSvg from "@fishx/icons-svg/es/asn/ShoppingOutlined";
import FishxIcon from '../components/FishxIcon';

var ShoppingOutlined = function ShoppingOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingOutlinedSvg
  }));
};

ShoppingOutlined.displayName = 'ShoppingOutlined';
export default React.forwardRef(ShoppingOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShoppingOutlined.js
// module id = 4114
// module chunks = 0